import { FunctionComponent, useState } from "react";

import { GetApp } from "@material-ui/icons";
import { Popover, Tooltip } from "antd";
import styled from "styled-components/macro";
import { ExportFormat } from "utils/exportUtils";

import { IconSpinner } from "components/icons";

import { ActionButton } from "./ActionButton";

interface ExportButtonProps {
  exporting: boolean;
  onExport: (format: ExportFormat) => void;
}

export const ExportButton: FunctionComponent<ExportButtonProps> = ({
  exporting,
  onExport
}) => {
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);

  return (
    <Popover
      overlayClassName="export-popover"
      placement="bottomLeft"
      trigger="click"
      open={isExportMenuOpen}
      onOpenChange={(visible) => setIsExportMenuOpen(visible)}
      content={
        <ExportContainer>
          <ExportMenuButton
            data-testid="export-to-csv-button"
            disabled={exporting}
            onClick={() => {
              onExport(ExportFormat.CSV);
              setIsExportMenuOpen(false);
            }}>
            <GetApp fontSize="large" />
            <span className="button-text">Export to CSV (.csv)</span>
          </ExportMenuButton>
          <ExportMenuButton
            data-testid="export-to-excel-button"
            disabled={exporting}
            onClick={() => {
              onExport(ExportFormat.Excel);
              setIsExportMenuOpen(false);
            }}>
            <GetApp fontSize="large" />
            <span className="button-text">Export to Excel (.xlsx)</span>
          </ExportMenuButton>
        </ExportContainer>
      }>
      <Tooltip title="Export Data Table" mouseEnterDelay={0.6}>
        <ActionButton data-testid="export-chart-data-button">
          {exporting ? <IconSpinner /> : <GetApp fontSize="large" />}
        </ActionButton>
      </Tooltip>
    </Popover>
  );
};

const ExportContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  font-size: 1.4rem;
  font-weight: var(--fontWeightMedium);
  position: relative;
`;

const ExportMenuButton = styled.button`
  display: flex;
  justify-content: left;
  align-items: center;
  width: 200px;
  flex-shrink: 0;
  background-color: white;
  border: none;
  background: none;
  cursor: pointer;

  &:hover {
    background-color: var(--color-accent-hover);
    color: var(--color-text);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .button-text {
    display: inline-flex;
    cursor: pointer;
    padding-top: 14px;
    padding-bottom: 13px;
    padding-left: 10px;
    vertical-align: sub;
  }
`;
